import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import { useToast } from "../../contexts/ToastContext";

import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function CustomersViewModel(logout) {
  const { showSuccess } = useToast();
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState({
    data: [],
  });
  const [customerGroupOptions, setCustomerGroupOptions] = useState(null);

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getCustomers = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`customers`, payload);
    setLoading(false);
    if (callResult.success) {
      setCustomers(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const getCustomerGroupsForDropdown = async function () {
    setLoading(true);

    let callResult = await makePostApiCall(`getCustomersGroupsForDropdown`);
    setLoading(false);
    if (callResult.success) {
      setCustomerGroupOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const onBulkAction = async function (bulkActionValues) {
    let callResult = await makePostApiCall(
      `bulkAction/customers`,
      bulkActionValues
    );
    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Bulk action completed"
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const deleteCustomer = async function (id) {
    const callResult = await makePostApiCall(`customers/delete/${id}`, {});
    if (callResult.success) {
      showSuccess(callResult.data?.message || "Customer deleted");
      getCustomers(null, 1);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      } else {
        showErrorModal(
          "Could not delete customer",
          callResult.data?.message || "Please try again."
        );
      }
    }
  };

  const askDeleteCustomer = function (customer) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          title="Delete customer"
          buttonMessage="Delete"
          message={`Are you sure you want to delete "${customer.company_name || customer.given_name || "this customer"}"? This action cannot be undone.`}
          setOpen={setEmptyModelOpen}
          confirmAction={async () => {
            await deleteCustomer(customer.id);
            setEmptyModelOpen({ childComponent: null, open: false });
          }}
        />
      ),
      open: true,
    });
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    getCustomers,
    loading,
    customers,
    setSlideOver,
    slideOver,
    getCustomerGroupsForDropdown,
    customerGroupOptions,
    onBulkAction,
    askDeleteCustomer,
  };
}
